import { toast as sonnerToast } from 'sonner';

interface ToastOptions {
  title?: string;
  description?: string;
  status?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  isClosable?: boolean;
  position?: string;
}

/**
 * Compatibility wrapper around sonner toast.
 * Provides Chakra-style toast({ title, description, status }) API.
 */
export function useToast() {
  const toastFn = (options: ToastOptions) => {
    const { title, description, status = 'info', duration } = options;
    const message = title || '';
    const opts: any = {};
    if (description && title) opts.description = description;
    if (duration) opts.duration = duration;

    switch (status) {
      case 'success':
        return sonnerToast.success(message || description || '', opts);
      case 'error':
        return sonnerToast.error(message || description || '', opts);
      case 'warning':
        return sonnerToast.warning(message || description || '', opts);
      default:
        return sonnerToast.info(message || description || '', opts);
    }
  };

  toastFn.close = (id: string | number) => {
    sonnerToast.dismiss(id);
  };

  toastFn.closeAll = () => {
    sonnerToast.dismiss();
  };

  return toastFn;
}
